import { CustomElement } from '../types';

export const deserializeFromHtml = (html: string): CustomElement[] => {
  // TODO: Implement HTML deserialization
  console.log('Deserialize from HTML:', html);
  return [
    {
      type: 'paragraph',
      children: [{ text: 'HTML deserialization not implemented yet' }],
    },
  ];
}; 